<template>
    <template v-if="hasExtraButtons">
        <a-button
            v-for="(button, i) in buttons"
            :key="`form-reg-extra-button-${i}`"
            class="extra-button"
            v-bind="button"
            :event="button.event || { doNotSendGA: true }"
            @click="$emit('button-click', button)"
        />
    </template>
</template>

<script setup>
import { computed } from 'vue';
import AButton from '@core/components/button/button.vue';

defineOptions({
    name: 'FormExtraButtons',
});

const props = defineProps({
    buttons: {
        type: Array,
        default: () => [],
    },
});

defineEmits(['button-click']);

const hasExtraButtons = computed(() => Boolean(props.buttons?.length));
</script>

<style lang="postcss" scoped>
.extra-button {
    width: 100%;
    margin: 16px 0 0;

    &.a-button_type_inverse {
        border-radius: 4px;
        border: 1px solid var(--av-brand-primary);

        &:hover {
            background: var(--av-brand-accent);
        }

        &:active {
            background: var(--el-secondary-active);
        }

        :deep(.a-button__content) {
            color: var(--av-brand-primary);
            @mixin paragraph-accent;
        }
    }
}
</style>
